import { ElementRef } from '@angular/core';

import { TrackingService } from './tracking.service';

/**
 * Attaches click tracking to elements with the `data-track-action` attribute.
 * This function will add an event listener to each element that matches the selector.
 *
 * @param containerRef
 * @param trackingService
 * @param event - The event to track (e.g., 'click', 'mouseover').
 * @returns
 */
export function attachTrackingToDescription(
  trackingService: TrackingService,
  event: keyof HTMLElementEventMap = 'click',
  containerRef: ElementRef | undefined
): void {
  const container = containerRef?.nativeElement;
  if (!container) return;

  const trackableElements = container.querySelectorAll('[data-track-action]');

  trackableElements.forEach((el: HTMLElement) => {
    el.addEventListener(event, () => {
      const action = el.getAttribute('data-track-action') ?? 'click';
      const category = el.getAttribute('data-track-category') ?? 'MovieSite';
      const label = el.getAttribute('data-track-label') ?? el.textContent?.trim() ?? '';

      trackingService.trackEvent({
        action,
        properties: {
          category,
          label
        }
      });
    });
  });
}
